import { useMutation, FetchResult } from "@apollo/client";

import { RESET_PASSWORD } from "./forgotPassword.mutations";

interface ResetPasswordProps {
  variables: {
    store?: string;
    login: string;
    password: string;
    eventId: string;
    document?: string;
  };
}

export const useResetPassword = (): {
  resetPassword: (options: ResetPasswordProps) => Promise<FetchResult>;
} => {
  const [resetPasswordMutation] = useMutation(RESET_PASSWORD);

  const resetPassword = (options: ResetPasswordProps): Promise<FetchResult> => {
    return resetPasswordMutation(options);
  };

  return { resetPassword };
};
